<template>
    <li v-show="hasQuestions || isFolder || hasCriteria">
        <div>
          <i v-if="icon" :class="icon + ' mr-1'"></i>
          <span class="pointer toggle_ti" @click="toggle">
            {{ item.title }}
            <span v-if="isFolder || hasQuestions || hasCriteria" class="toggle-tree-item">
              <i v-if="isOpen" class="tim-icons icon-minimal-down"></i>
              <i v-else class="tim-icons icon-minimal-right"></i>
            </span>
          </span>
        </div>
        <div class="table-responsive" style="overflow:auto;" v-if="hasQuestions" v-show="isOpen">
          <table class="table" style="width: 100%; min-width: 700px;">
            <tbody>
              <tr class="row-below" v-for="(questionDto, index) in item.questionDtos" :key="index">
                <td class="p-2">
                  {{ questionDto.title }}
                </td>
                <td class="p-2">
                  <div class="text-black" v-if="questionDto.evaluationId">
                    <div v-if="questionDto.isNumericIndex">
                      <div v-if="questionDto.analystAnswerNumeric !== '' && questionDto.analystAnswerNumeric !== null">
                        {{ formatNumber(questionDto.analystAnswerNumeric) }}
                        <small v-if="questionDto.analystAnswerText" class="pointer text-primary ml-1" @click="toggleEvaluationNotes(questionDto.evaluationId);"><i class="icomoon-info"></i> details</small>
                      </div>
                      <div v-else>
                        N/A
                        <small v-if="questionDto.analystAnswerText" class="pointer text-primary ml-1" @click="toggleEvaluationNotes(questionDto.evaluationId);"><i class="icomoon-info"></i> details</small>
                      </div>
                      <div v-if="questionDto.analystAnswerText" v-show="evaluationsNotes.indexOf(questionDto.evaluationId)>-1" v-html="questionDto.analystAnswerText" class="text-muted evaluation_answer_notes"></div>
                    </div>
                    <div v-else>
                      <div v-if="questionDto.analystAnswerText" v-html="questionDto.analystAnswerText"></div>
                      <div v-else>N/A</div>
                    </div>
                  </div>
                  <div class="text-black" v-else>N/A</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-responsive" style="overflow:auto;" v-if="hasCriteria" v-show="isOpen">
          <table class="table" style="width: 100%;">
            <tbody>
              <tr class="row-below" v-for="(criterionDto, index) in item.criteriaDtos" :key="index">
                <td :id="'criterion_td_' + criterionDto.id" class="criterion_td pointer" @click="emitCriterionClickedEvent(criterionDto)">
                  {{ criterionDto.title }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ul v-show="isOpen" v-if="isFolder">
          <tree-item
            class="tree-item"
            v-for="(child, index) in item.childrenDtos"
            :key="index"
            :item="child"
            @criterionClicked="emitCriterionClickedEvent"
          ></tree-item>
        </ul>
    </li>
</template>
<script>
export default {
  name: "tree-item",
  props: {
    item: Object,
    icon: {
      type: String,
      default: null
    },
    isOpenInit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: this.isOpenInit,
      evaluationsNotes: []
    };
  },
  computed: {
    isFolder () {
      return this.item.childrenDtos && this.item.childrenDtos.length>0;
    },
    hasQuestions () {
      return this.item.questionDtos && this.item.questionDtos.length>0;
    },
    hasCriteria () {
      return this.item.criteriaDtos && this.item.criteriaDtos.length>0;
    }
  },
  methods: {
    toggle () {
      if (this.isFolder || this.hasQuestions || this.hasCriteria) {
        this.isOpen = !this.isOpen;
      }
    },
    formatNumber(number) {
      if (number > 1000000000000) {
        return (number/1000000000000).toFixed(2) + 'T'
      }

      if (number > 1000000000) {
        return (number/1000000000).toFixed(2) + 'B'
      }

      if (number > 1000000) {
        return (number/1000000).toFixed(2) + 'M'
      }

      if (number > 1000) {
        return (number/1000).toFixed(2) + 'K'
      }

      return number;
    },
    emitCriterionClickedEvent(event) {
      this.$emit("criterionClicked", event);
    },
    toggleEvaluationNotes(evaluationId) {
      let indexOf = this.evaluationsNotes.indexOf(evaluationId);
      if (indexOf === -1) {
        this.evaluationsNotes.push(evaluationId)
      } else {
        this.evaluationsNotes.splice(indexOf,1);
      }
    }
  }
};
</script>
<style>
.toggle-tree-item {
  cursor: pointer;
  margin-left: 5px;
  margin-right: 5px;
}
.table td {
  width: 50%;
}
.text-black {
  color: #222222 !important;
}
.pointer {
  cursor: pointer;
}
.environmental .criterion_td.selected {
  background-color: #6ae1ab;
}
.social .criterion_td.selected {
  background-color: #ffc55b;
}
.governance .criterion_td.selected {
  background-color: #9e9eff;
}
.financial .criterion_td.selected {
  background-color: #ffa2a2;
}
.general .criterion_td.selected {
  background-color: #e7e7ec;
}
.evaluation_answer_notes {
  font-size: 80%;
  color: #6c757d !important;
  line-height: 1.3em;
}
</style>
